import React, { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { PLATFORM_BADGES } from '../lib/platformLogos';
import './PlatformMarquee.css';

function PlatformBadge({ platform }) {
  const [logoFailed, setLogoFailed] = useState(false);
  const showLogo = Boolean(platform.logoPath) && !logoFailed;

  return (
    <span className="platform-marquee-pill">
      <span
        className="platform-marquee-icon"
        style={{ backgroundColor: platform.brandColor }}
        aria-hidden
      >
        {showLogo ? (
          <img
            src={platform.logoPath}
            alt=""
            className={`platform-marquee-icon-img${platform.invertLogo ? ' platform-marquee-icon-img--invert' : ''}`}
            onError={() => setLogoFailed(true)}
          />
        ) : (
          <span className="platform-marquee-icon-fallback">{platform.fallbackIcon}</span>
        )}
      </span>
      <span className="platform-marquee-name">{platform.name}</span>
    </span>
  );
}

const PlatformMarquee = () => {
  const reduceMotion = useReducedMotion();
  const track = reduceMotion ? PLATFORM_BADGES : [...PLATFORM_BADGES, ...PLATFORM_BADGES];

  return (
    <div className="platform-marquee" aria-label="Supported publishing platforms">
      <motion.div
        className="platform-marquee-track"
        animate={reduceMotion ? false : { x: ['0%', '-50%'] }}
        transition={
          reduceMotion
            ? undefined
            : {
                x: {
                  repeat: Infinity,
                  repeatType: 'loop',
                  duration: 28,
                  ease: 'linear',
                },
              }
        }
      >
        {track.map((platform, index) => (
          <PlatformBadge key={`${platform.name}-${index}`} platform={platform} />
        ))}
      </motion.div>
    </div>
  );
};

export default PlatformMarquee;
